import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.css'],
})
export class UserModalComponent {
  constructor(
    private changeDetector: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  @Input("max-width") maxWidth: string;
  header!: string;
  body!: SafeHtml;
  okClick?: (() => void) | (() => Promise<void>);
  isShown = false;


  show(
    header: string,
    body: string,
    okClick: (() => void) | (() => Promise<void>)
  ) {
    this.header = header;
    this.body = this.sanitizer.bypassSecurityTrustHtml(body);
    this.okClick = okClick;
    this.isShown = true;
    this.changeDetector.detectChanges();
  }

  async onOkClick() {
    await Promise.resolve(this.okClick());

    this.isShown = false;

  }

  close() {
    this.isShown = false;
    this.changeDetector.detectChanges();
  }
}
